// extracted by mini-css-extract-plugin
module.exports = {"editorContainer":"BoolEditor_editorContainer"};